import { render, staticRenderFns } from "./file-chooser.vue?vue&type=template&id=9f731534&scoped=true&"
import script from "./file-chooser.vue?vue&type=script&lang=js&"
export * from "./file-chooser.vue?vue&type=script&lang=js&"
import style0 from "./file-chooser.vue?vue&type=style&index=0&id=9f731534&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f731534",
  null
  
)

export default component.exports